import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";

const AssetMetersPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Assign Meters">
      </MasterLayout>
    </>
  );
};

export default AssetMetersPage;
